import { render, staticRenderFns } from "./SelectTable.vue?vue&type=template&id=8916227c&"
import script from "./SelectTable.vue?vue&type=script&lang=ts&"
export * from "./SelectTable.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTable.vue?vue&type=style&index=0&id=8916227c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports